/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicationResourceTypeDto = {
    EmployeeProfile: 'EMPLOYEE_PROFILE',
    Survey: 'SURVEY',
    ExamDay: 'EXAM_DAY',
    IndividualExam: 'INDIVIDUAL_EXAM',
    TestTerm: 'TEST_TERM'
} as const;

export type ApplicationResourceTypeDto = typeof ApplicationResourceTypeDto[keyof typeof ApplicationResourceTypeDto];



